import { Component, ViewChild } from "@angular/core";
import { CardTableComponent } from "src/app/components/cards/card-table/card-table.component";
import { CrudComponent } from "src/app/components/shared/cruds/crud.component";
import { Condition } from "src/app/models/custom-types";
import { FilterEvent } from "src/app/models/filter";
import { ListColumn } from "src/app/models/list-columns.model";
import { PlantasDTO } from "src/app/models/plantas.dto";
import { LayoutsService } from "src/app/services/layouts.service";
import { Filter } from "src/app/shared/classes/filter";
import { PlantasService } from "./plantas.service";
import { AlertasSwalService } from "src/app/services/alerts.service";
import { PlantasDrawerForm } from "./drawer-form/drawer-form.component";
import { DrawerService } from "src/app/services/drawer.service";

@Component({
  selector: "app-plantas",
  templateUrl: "./plantas.component.html",
  styles: [],
})
export class PlantasComponent extends CrudComponent<PlantasDTO> {
  columnId: string = "IdPlanta";
  public columns: ListColumn[] = [
    {
      name: "Nombre",
      property: "Nombre",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "actions",
      property: "actions",
      visible: true,
      isModelProperty: false,
    },
  ];
  realdata: any[];
  constructor(
    public service: PlantasService,
    private layoutService: LayoutsService,
    public alerts: AlertasSwalService,
    private drawer: DrawerService
  ) {
    super(service, alerts);
  }

  ngOnInit(): void {
    this.loadRecords();
    this.layoutService.changeHeader("Plantas");
    this.filter = new Filter<PlantasDTO>(this.conditions, this.columns, true);
    this.filter.setColumnActive(this.columnActive);
  }

  loadRecords() {
    this.service.get().subscribe(
      (resultData) => {
        this.realdata = resultData;
        this.filter.setDataTable(this.realdata, this.tableComp);
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      }
    );
  }

  //#region Filter

  public filter: Filter<PlantasDTO>;
  public conditions: Condition<PlantasDTO> = {
    Nombre: (o, f) => (o.Nombre ?? "").toLocaleLowerCase().indexOf(f) > -1,
  };

  filterdata(e: FilterEvent) {
    this.filter.filterdata(e, this.realdata, this.tableComp);
  }

  //#endregion Filter

    openUser() {
      const drawerRef = this.drawer.open({
        component: PlantasDrawerForm,
        data: { mode: "create", value: {} },
        width: "500px",
        title: "Plantas",
        classes: "bg-blueGray-100",
        actions: [
          {
            label: "Cancel",
            action: () => this.drawer.close(),
            buttonClass: "bg-red-600",
          },
          {
            label: "Guardar",
            action: (component: PlantasDrawerForm) => component.saveOver(),
          },
        ],
      });

      drawerRef.afterClosed$.subscribe((result: any) => {
        this.saveForm(result.data);
      });
    }

    override openEdit(value: any) {
      const drawerRef = this.drawer.open({
        component: PlantasDrawerForm,
        data: { mode: "update", value: value },
        width: "500px",
        title: "Plantas",
        classes: "bg-blueGray-100",
        actions: [
          {
            label: "Cancel",
            action: () => this.drawer.close(),
            buttonClass: "bg-red-600",
          },
          {
            label: "Actualizar",
            action: (component: PlantasDrawerForm) => component.saveOver(),
          },
        ],
      });

      drawerRef.afterClosed$.subscribe((result: any) => {
        this.saveForm(result.data);
      });
    }
    public tableActionsCC = [
      {
        label: "Nuevo",
        icon: "plus",
        className:
          "text-xs font-bold uppercase px-3 py-2 rounded shadow hover:shadow-md bg-blueGray-600 text-white disabled:opacity-50",
        action: () => this.openUser(),
      },
    ];
}
